export default __webpack_public_path__ + "static/logos-tiles-georges-d3426f3f003c3821a16a252fc296ecc2.svg";